import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const FolderRoot = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <g fillRule="nonzero">
      <path d="M22 17.501v-10c0-.827-.673-1.5-1.5-1.5H13a.406.406 0 01-.276-.171l-.553-1.106C11.964 4.311 11.461 4 11 4H4c-.461 0-.965.311-1.171.724L2.276 5.83A3.022 3.022 0 002 7.001v10.5c0 .827.673 1.5 1.5 1.5h17c.827 0 1.5-.673 1.5-1.5zm-19 .001v-10.5c0-.197.083-.548.171-.724l.553-1.106A.404.404 0 014 5.001h7c.085 0 .238.094.276.171l.553 1.106c.206.413.71.724 1.171.724h7.5a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5z"></path>
      <path d="M23 7.001v10.873a2.127 2.127 0 01-2.127 2.127H4s0 1 1 1h15.873c1.727 0 3.127-1.4 3.127-3.127V7.998c0-.998-1-.997-1-.997z"></path>
      <path d="M13.724 9.054a.5.5 0 00-.671.223l-3 6a.5.5 0 10.894.448l3-6a.5.5 0 00-.223-.671z"></path>
    </g>
  </SvgIcon>
);

export default FolderRoot;
